export type ProtocolPriority = "LOW" | "NORMAL" | "HIGH" | "CRITICAL";
export type ProtocolStatus = "OPEN" | "IN_PROGRESS" | "RESOLVED" | "CANCELED";
export type ProtocolAttachment = {
  key: string;
  fileName: string;
  contentType?: string;
  size: number;
  url: string;
  createdAt?: string;
};
export type Protocol = {
  id: string;
  protocolNumber: string;
  title: string;
  description: string;
  requesterId?: string;
  requesterName?: string;
  conversationId?: string;
  assignedToSystemUserId?: string;
  assignedToName?: string;
  status: ProtocolStatus;
  priority: ProtocolPriority;
  createdAt: string;
  dueAt?: string;
  closedAt?: string;
  version: number;
  sla?: "ADEQUATE" | "WARNING" | "OVERDUE" | null;
  resolution?: string;
  cancellationReason?: string;
  actorNames?: Record<string, string>;
  attachments?: ProtocolAttachment[];
  comments?: {
    id: string;
    text: string;
    actorSystemUserId: string;
    createdAt: string;
  }[];
  events?: {
    id: string;
    type: string;
    actorType: string;
    actorSystemUserId?: string;
    createdAt: string;
    changes?: Record<string, unknown>;
  }[];
};
export const priorityLabels: Record<ProtocolPriority, string> = {
  LOW: "Baixa",
  NORMAL: "Normal",
  HIGH: "Alta",
  CRITICAL: "Crítica",
};
export const statusLabels: Record<ProtocolStatus, string> = {
  OPEN: "Aberto",
  IN_PROGRESS: "Em andamento",
  RESOLVED: "Resolvido",
  CANCELED: "Cancelado",
};
export const slaLabels = {
  ADEQUATE: "Dentro do prazo",
  WARNING: "Próximo do vencimento",
  OVERDUE: "Vencido",
};
export const protocolDate = (value?: string) =>
  value
    ? new Intl.DateTimeFormat("pt-BR", {
        dateStyle: "short",
        timeStyle: "short",
        timeZone: "America/Sao_Paulo",
      }).format(new Date(value))
    : "Sem prazo";
